import './less/tabs.less';

class NTabs {
	
	constructor(){
		this.initTabs();
	}
	
	initTabs() {
		let _this = this;
		_this.tabs = $('#nTabs-' + $(this).closest($('.tabs__header')).data('tabs'));

		$('.tab-content').first().fadeIn();
		
		$('.tab-changer').click(function(){
			if ($(window).width() >= 992) {
				$('.tab-changer').removeClass('active');
				$(this).addClass('active');
				_this.showTab($(this).data('tab'));
			} else {
				window.location.href = $(this).data('url');
			}
		});
		
		Array.from(document.getElementsByClassName('js-mobile-tabs-expander'))
			.map(expander => {
				expander.addEventListener('click', e => {
					e.currentTarget.nextElementSibling.classList.add('opened');
                    e.currentTarget.previousElementSibling.classList.add('active');
				});
			});
        
        Array.from(document.getElementsByClassName('js-mobile-tabs-closer'))
            .map(closer => {
                closer.addEventListener('click', e => {
                    e.currentTarget.parentElement.getElementsByClassName('tabs__header')[0].classList.remove('opened');
                    e.currentTarget.classList.remove('active');
                });
            });
	}
	
	showTab(tab) {
		let hideAll = $('.tab-content').fadeOut().promise();
		
		$.when(hideAll).done(()=>{
			this.tabs.find($('.tab_' + tab).fadeIn());
		});

	}
}

export { NTabs };


// WEBPACK FOOTER //
// ./components/tabs/tabs.js